import React, { useState, useEffect } from "react";
import "./YogaLibrary.css";
import { yogaDetails } from "./data/YogaDetails";

const yogaPoses = [
  { id: 1, name: "ARDHACAKRASANA", english: "Half Wheel Pose" },
  { id: 2, name: "BHUJANGASANA", english: "Cobra Pose" },
  { id: 3, name: "CHAKRASANA", english: "Wheel Pose" },
  { id: 4, name: "DHANURASANA", english: "Bow Pose" },
  { id: 5, name: "ARDHA HALASANA", english: "Half Plough Pose" },
  { id: 6, name: "HALASANA", english: "Plough Pose" },
  { id: 7, name: "MATSYASANA", english: "Fish Pose" },
  { id: 8, name: "NATARAJASANA", english: "Lord of the Dance Pose" },
  { id: 9, name: "PASCHIMOTTANASANA", english: "Seated Forward Bend" },
  { id: 10, name: "SALABHASANA", english: "Locust Pose" },
  { id: 11, name: "SARVANGASANA", english: "Shoulder Stand" },
  { id: 12, name: "SASANKASANA", english: "Rabbit Pose" },
  { id: 13, name: "SIRSASANA", english: "Headstand" },
  { id: 14, name: "TRIKONASANA", english: "Triangle Pose" },
  { id: 15, name: "USHTRASANA", english: "Camel Pose" },
  { id: 16, name: "VAJRASANA", english: "Thunderbolt Pose" },
  { id: 17, name: "SIDDHASANA", english: "Accomplished Pose" },
  { id: 18, name: "GOMUKHASANA", english: "Cow Face Pose" },
  { id: 19, name: "SIMHASANA", english: "Lion Pose" },
  { id: 20, name: "PADMASANA", english: "Lotus Pose" },
  { id: 21, name: "TADASANA", english: "Mountain Pose" },
  { id: 22, name: "VRIKSHASANA", english: "Tree Pose" },
  { id: 23, name: "UTTANPADASANA", english: "Raised Leg Pose" },
  { id: 24, name: "SETU BANDHA SARVANGASANA", english: "Bridge Pose" },
  { id: 25, name: "MAKARASANA", english: "Crocodile Pose" },
  { id: 26, name: "PARVATASANA", english: "Mountain Stretch / Downward Dog" },
  { id: 27, name: "BAKASANA", english: "Crow Pose" },
  { id: 28, name: "KAPALBHATI", english: "Skull Shining Breathing" },
  { id: 29, name: "ANULOM VILOM", english: "Alternate Nostril Breathing" },
  { id: 30, name: "BHRAMARI", english: "Bee Breathing" },
  { id: 31, name: "SURYA NAMASKAR", english: "Sun Salutation" },
  { id: 32, name: "SHAVASANA", english: "Corpse Pose" }
];

function YogaLibrary() {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedPose, setSelectedPose] = useState(null);

  // ESC key close
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        setSelectedPose(null);
      }
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, []);

  return (
    <div className="yoga-wrapper">

      {/* Toggle Button */}
      <button
        className="yoga-toggle-btn"
        onClick={() => {
          setIsOpen(!isOpen);
          setSelectedPose(null);
        }}
      >
        🧘 Yoga Library (32 Postures)
      </button>

      {/* Grid */}
      {isOpen && (
        <div className="yoga-grid">
          {yogaPoses.map((pose) => (
            <div
              key={pose.id}
              className="yoga-card"
              onClick={() => setSelectedPose(pose)}
            >
              <img
                src={`/yoga/${pose.id}.png`}
                alt={pose.name}
              />
              <h4>{pose.name}</h4>
              <p className="english-name">{pose.english}</p>
            </div>
          ))}
        </div>
      )}

      {/* Modal Popup */}
      {selectedPose && (
        <div
          className="modal-overlay"
          onClick={() => setSelectedPose(null)}
        >
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="modal-close"
              onClick={() => setSelectedPose(null)}
            >
              ✕
            </button>

            <h2>{selectedPose.name}</h2>
            <h4>{selectedPose.english}</h4>

            <img
              className="modal-image"
              src={`/yoga/${selectedPose.id}.png`}
              alt={selectedPose.name}
            />

            <h3>Steps:</h3>
            <ol className="steps-list">
              {yogaDetails[selectedPose.id]?.steps.map((step, index) => (
                <li key={index}>{step}</li>
              ))}
            </ol>

            <h3>Benefits:</h3>
            <p>{yogaDetails[selectedPose.id]?.benefits}</p>

            <h3>Precautions:</h3>
            <p>{yogaDetails[selectedPose.id]?.precautions}</p>

            <a
              href={`https://www.youtube.com/results?search_query=${selectedPose.name}+yoga`}
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-button"
            >
              ▶ Watch on YouTube
            </a>

          </div>
        </div>
      )}

    </div>
  );
}

export default YogaLibrary;